import { BookOutlined } from '@mui/icons-material';
import { Box, Divider, InputAdornment } from '@mui/material';
import { useMemo } from 'react';
import { ReadOnlyField } from '../../../components/fields/ReadOnlyField.tsx';

type PDFFieldProps = {
  label: string;
  value: File | null;
  onChange: (file: File | null) => void;
  onBlur?: () => void;
  disabled?: boolean;
  focused?: boolean;
  error?: boolean;
  helperText?: string;
};

export const PDFField = ({ value, onChange, ...props }: PDFFieldProps) => {
  const fileURL = useMemo<string | null>(
    () => (value ? URL.createObjectURL(value) : null),
    [value],
  );
  const acceptedType = 'application/pdf';

  return (
    <ReadOnlyField
      label={props.label}
      disabled={props.disabled}
      onBlur={props.onBlur}
      focused={props.focused}
      error={props.error}
      helperText={props.helperText}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <BookOutlined />
            </InputAdornment>
          ),
        },
      }}
      fullWidth
    >
      <Box
        component="input"
        type="file"
        accept={acceptedType}
        sx={{ width: '100%', cursor: 'pointer' }}
        onChange={(e) => {
          if (e.target instanceof HTMLInputElement && e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            if (file.type !== acceptedType && !file.name.toLowerCase().endsWith('.pdf')) {
              throw new Error('Invalid file type');
            } else {
              onChange(file);
            }
          }
        }}
      />
      {fileURL && (
        <>
          <Divider sx={{ my: 2 }} />
          <object data={fileURL} type="application/pdf" width="100%" height="500px">
            <p>PDF not supported</p>
          </object>
        </>
      )}
    </ReadOnlyField>
  );
};
